import { Component } from '@angular/core';
import {
  IFloatingFilter
} from 'ag-grid-community';

@Component({
  template: `
    <select [(ngModel)]="currentValue" (ngModelChange)="valueChanged()" class="form-control">
    <option value="All">All</option>
    <option value="Active">Active</option>
    <option value="Suspended">Suspended</option>
    <option value="User Action Required">User Action Required</option>
  </select>`,
})
export class SelectFloatingFilterComponent implements IFloatingFilter {
  private params;
  public currentValue: string = 'All';

  agInit(params: any): void {
    this.params = params;
  }

  valueChanged() {
    const model = this.params.api.getFilterModel();
    model.status = {
      filter: this.currentValue
    }
    this.params.api.setFilterModel(model);
  }

  onParentModelChanged(parentModel): void {
  }
}
